import React from 'react';
import { StyledTitle, StyledSectionTitle } from './styled.js';

export const Title = ({ children }) =>
  <StyledTitle>
    {children}
  </StyledTitle>;

export const SectionTitle = ({ children, toolTipComponent }) => {
  if (!children) {
    return null;
  }

  return (<StyledSectionTitle>
    {children}
    {toolTipComponent}
  </StyledSectionTitle>);
};
